<template>
  <fieldset>
    <FormulateInput
      name="reasonofterminationsituation"
      :options="{
        work: i18n.form.labels.reasonofterminationsituationoptions.work,
        relocation: i18n.form.labels.reasonofterminationsituationoptions.relocation,
        independence: i18n.form.labels.reasonofterminationsituationoptions.independence,
        doesnotwanttogo: i18n.form.labels.reasonofterminationsituationoptions.doesnotwanttogo,
        other: i18n.form.labels.reasonofterminationsituationoptions.other,
      }"
      type="radio"
      :label="i18n.form.labels.reasonofterminationsituation"
      validation="required"
      :validation-messages="i18n.form.validations.reasonofterminationsituation"
    />
    <FormulateInput
      v-if="showReasonInput"
      name="reasonofterminationsituationotherreason"
      type="textarea"
      validation="bail|required|nohtml"
      :validation-messages="i18n.form.validations.reasonofterminationsituationotherreason"
    />

    <FormulateInput
      v-if="showWorkInput"
      name="reasonofterminationsituationwork"
      :options="{
        yes: i18n.form.labels.reasonofterminationsituationworkoptions.yes,
        no: i18n.form.labels.reasonofterminationsituationworkoptions.no,
      }"
      type="radio"
      :label="i18n.form.labels.reasonofterminationsituationwork"
      validation="required"
      :validation-messages="i18n.form.validations.reasonofterminationsituationwork"
    />

    <FormulateInput
      v-if="showLocationInput"
      name="reasonOfTerminationSituationIsPartouLocation"
      :options="{
        yes: i18n.form.labels.reasonOfTerminationSituationIsPartouLocationOptions.yes,
        no: i18n.form.labels.reasonOfTerminationSituationIsPartouLocationOptions.no,
      }"
      type="radio"
      :label="i18n.form.labels.reasonOfTerminationSituationIsPartouLocation"
      validation="required"
      :validation-messages="i18n.form.validations.reasonOfTerminationSituationIsPartouLocation"
    />

    <FormulateInput
      v-if="showDoesNotWantToGoInput"
      :label="i18n.form.labels.reasonofterminationsituationdoesnotwanttogo"
      name="reasonofterminationsituationdoesnotwanttogo"
      type="textarea"
      validation="bail|required|nohtml"
      :validation-messages="i18n.form.validations.reasonofterminationsituationdoesnotwanttogo"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsReasonOfTerminationSituation',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showReasonInput() {
      return this.model.reasonofterminationsituation === 'other';
    },
    showWorkInput() {
      return this.model.reasonofterminationsituation === 'work';
    },
    showLocationInput() {
      return this.model.reasonofterminationsituation === 'relocation';
    },
    showDoesNotWantToGoInput() {
      return this.model.reasonofterminationsituation === 'doesnotwanttogo';
    },
  },
};
</script>
